module.exports = __webpack_public_path__ + "img/tag_yjcx.2526cc0c.png";